import React from 'react';
import { Main } from './components';

// 🎯 Componente simplificado - sin validación de permisos
const Packs: React.FC = () => {
    return <Main />;
};

export default Packs; 